import OldInput, { OldInputState } from "./OldInput";
import PasswordInput, { PasswordDots } from "./PasswordInput";
import InputWithLabel from "./InputWithLabel";
import Input from "./Input";
import { InputState } from "./interface";

export default Input;
export type { InputState };
export { OldInput, PasswordInput, OldInputState, PasswordDots, InputWithLabel };
